<script setup lang="ts">
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/vue'

const props = defineProps<{
  label: string
  name: string
  placeholder?: string
  options?: { name: string; value: string }[]
  required?: boolean
}>()

const selected = ref({ name: props.placeholder, value: null })
</script>

<template>
  <ClientOnly>
    <input type="hidden" :value="selected.value" :name="name" >

    <Listbox v-model="selected" as="div" class="font-mono text-sm uppercase">
      <ListboxLabel class="block">
        {{ label }} ({{ required ? 'Required' : 'Optional' }})
      </ListboxLabel>

      <div class="relative mt-2">
        <ListboxButton
          class="grid w-full cursor-default grid-cols-1 p-3 text-left outline-1 -outline-offset-1 outline-black/50 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
        >
          <span class="col-start-1 row-start-1 flex items-center gap-3 pr-6 uppercase">
            <span class="block truncate" :class="!selected.value ? 'text-black/50' : ''">
              {{ selected.name }}
            </span>
          </span>
          <IconsChevronDown
            class="col-start-1 row-start-1 size-3 self-center justify-self-end text-gray-500 sm:size-4"
            aria-hidden="true"
          />
        </ListboxButton>

        <transition
          leave-active-class="transition ease-in duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <ListboxOptions
            data-lenis-prevent
            class="absolute z-10 mt-1 ml-px max-h-56 w-[calc(100%-2px)] overflow-auto overscroll-contain bg-white ring-1 ring-black/50 focus:outline-hidden sm:text-sm"
          >
            <ListboxOption
              v-for="option in options"
              :key="option.value"
              v-slot="{ active, selected }"
              as="template"
              :value="option"
            >
              <li
                :class="[
                  active ? 'bg-light-grey outline-hidden' : '',
                  'relative cursor-default p-3 select-none',
                ]"
              >
                <div class="flex items-center">
                  <span
                    class="block truncate"
                    :class="[selected ? 'font-semibold' : 'font-normal']"
                  >
                    {{ option.name }}
                  </span>
                </div>
              </li>
            </ListboxOption>
          </ListboxOptions>
        </transition>
      </div>
    </Listbox>
  </ClientOnly>
</template>
